import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { bannerMessageSchema } from "@opstel/query/v2/models/bannerMessage";
import { useQuery } from "@tanstack/react-query";

export function useBannerMessageQuery() {
  const { opstelClient } = useOpstelClient();

  return useQuery({
    queryKey: ["bannerMessage"],
    queryFn: async () => await opstelClient.getBannerMessage(),
    select: (data) => bannerMessageSchema.parse(data),
  });
}
